import { render, staticRenderFns } from "./GroupPorps.vue?vue&type=template&id=531bbcc0&scoped=true&"
import script from "./GroupPorps.vue?vue&type=script&lang=js&"
export * from "./GroupPorps.vue?vue&type=script&lang=js&"
import style0 from "./GroupPorps.vue?vue&type=style&index=0&id=531bbcc0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bbcc0",
  null
  
)

export default component.exports